import angular from 'angular';

export default angular
  .module('app.filters.unsafe', [])
  .filter('unsafe', $sce => val => $sce.trustAsHtml(val));
